import type {
  SizeType,
  TFlexDirection,
  TFontDecoration,
  TPaddingSystem,
  TRoundedSystem
} from '@/modules/perseo-billing/components/form/ui.interface';

export function createPadding({ pl, pr, pb, pt }: TPaddingSystem): string {
  return `co-pl-${pl}px co-pr-${pr}px co-pt-${pt}px co-pb-${pb}px`;
}

export function createSize(value: SizeType): string {
  if (value === 'large') {
    return 'co-w-48px co-h-48px';
  }
  if (value === 'medium') {
    return 'co-w-32px co-h-32px';
  }
  return 'co-w-24px co-h-24px';
}

export function createDecorationText(
  decoration: TFontDecoration['underline']
): string {
  if (decoration === 'none') {
    return 'hover:co-no-underline co-no-underline';
  }
  if (decoration === 'always') {
    return 'hover:co-underline co-underline';
  }
  return 'co-no-underline hover:co-underline';
}

export function capitalizeFisrtLetter(value: string): string | null {
  if (!value) return null;
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function createRounded(value: TRoundedSystem['rounded']): string {
  if (value === 'full') {
    return 'co-rounded-full';
  }
  if (value === 'none') {
    return 'co-rounded-none';
  }
  return `co-rounded-${value || 'none'}`;
}

export function createDirection(value: TFlexDirection['direction']): string {
  if (value === 'row') {
    return 'co-flex-row';
  }
  return 'co-flex-col';
}
